module.exports = __webpack_public_path__ + "img/banner_android_s.4991677.png";